import { useMutation, useQuery } from "@apollo/client";
import { useCallback, useMemo, useState } from "react";
import { FaCheck, FaPlus, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Loading, OutsideClick } from "../../Components";
import { ErrorToast, SuccessToast, WarningToast } from "../../Components/ToastComponent/RectHotToast";
import {
  CREATE_TASK_MANAGEMENT_BOARD,
  Delete_Board_mutation,
  EditBoardName,
  GET_ALL_TASK_MANAGEMENT_BOARD,
} from "./utils/quires";
import { useEventListener } from "usehooks-ts";
import { checkAccess } from "../../custom_hooks/CheckPageAccess";
import DeleteBoard from "./DeleteBoard";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { SlOptions } from "react-icons/sl";
const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 20px;
  flex-wrap: wrap;
  align-items: center; // Allows the boxes to wrap if there's not enough space
  .board-link-container {
    text-decoration: none;
  }

  .delete-button-board {
    height: 20px;
    width: 20px;
    color: red;
  }
`;

const BoxContainer = styled.div`
  position: relative;
  width: 12rem; // Adjusted width for better content management
  height: 6rem; // Increased height for vertical text centering
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  }
`;

const IconContainer = styled.div`
  position: absolute;
  top: 10px; // Position at the top right
  right: 10px;
  display: flex;
`;

const Text = styled.div`
  font-family: "Arial", sans-serif; // Using Arial as a common sans-serif font
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
`;

const OptionsMenu = styled.div`
  display: ${(props) => (props.show ? "block" : "none")};
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  z-index: 100;
`;
const OptionItem = styled.div`
  padding: 8px;
  &:hover {
    background-color: #f0f0f0;
    cursor: pointer;
  }
`;
const StatusBoard = () => {
  const [isAddingColumn, setIsAddingColumn] = useState(false);
  const [boardName, setBoardName] = useState("");
  const [toggle, settoggle] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [BorardTitle, setBoardTitle] = useState("");
  console.log({ BorardTitle }, "BorardTitleBorardTitleBorardTitleBorardTitle");
  const [RenameId, setRenameId] = useState("");
  const navigate = useNavigate();
  const { data: boardData, loading: boardLoading, error: boardError } = useQuery(GET_ALL_TASK_MANAGEMENT_BOARD);

  const [createBoard] = useMutation(CREATE_TASK_MANAGEMENT_BOARD, {
    refetchQueries: [{ query: GET_ALL_TASK_MANAGEMENT_BOARD }],
  });
  const [seletedId, setSelctedId] = useState("");
  const [DeleteBoard_Mutation, { loading: DeleteLoading }] = useMutation(Delete_Board_mutation, {
    refetchQueries: [{ query: GET_ALL_TASK_MANAGEMENT_BOARD }],
    onCompleted: (res) => {
      SuccessToast(res?.deleteTaskManagementBoard?.message);
    },
  });

  const [EditWorkBoardName] = useMutation(EditBoardName);
  const handleOpenNewColumn = () => setIsAddingColumn(true);
  const handleNewColumnNameChange = (e) => setBoardName(e.target.value);
  // Memoized access check value
  const access = useMemo(() => {
    return checkAccess("StatusBoard", "Delete");
  }, []); // Empty dependency array ensures this runs only once at mount
  //to create new board

  const handleAddNewColumn = async () => {
    if (boardName === "") {
      WarningToast("Please add a board name");
      return;
    }
    const normalizedBoardName = boardName.toLowerCase(); // Convert input to lower case

    const boardExists = boardData?.GetAllTaskManagementBoard.some(
      (board) => board.Board_Name.toLowerCase() === normalizedBoardName // Compare in lower case
    );
    if (boardExists) {
      WarningToast("A board with this name already exists. Please use a different name.");
      return;
    }

    try {
      await createBoard({
        variables: {
          createInput: {
            Board_Name: boardName,
          },
        },
      });
      handleCloseNewColumn();
      SuccessToast(`Board created successfully!`);
    } catch (error) {
      ErrorToast(`Error creating board!'`);
      console.error(error);
    }
  };
  const handleCloseNewColumn = () => {
    setIsAddingColumn(false);
    setBoardName("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape" && isAddingColumn) {
      handleCloseNewColumn();
    } else if (event.key === "Enter" && isAddingColumn) {
      handleAddNewColumn();
    }
  };
  const handleDeleteBoard = () => {
    DeleteBoard_Mutation({
      variables: {
        boardId: seletedId,
      },
    }).finally(() => {
      settoggle(false);
    });
  };
  const handleEDitTitlechange = (e) => {
    setBoardTitle(e.target.value);
  };
  const handleEditTitleBoard = async () => {
    if (BorardTitle === "") {
      WarningToast("Please add a board name");
      return;
    }
    const normalizedBoardName = BorardTitle.toLowerCase(); // Convert input to lower case

    const boardExists = boardData?.GetAllTaskManagementBoard.some(
      (board) => board.Board_Name.toLowerCase() === normalizedBoardName // Compare in lower case
    );
    if (boardExists) {
      WarningToast("A board with this name already exists. Please use a different name.");
      return;
    }

    try {
      await EditWorkBoardName({
        variables: {
          boardId: RenameId,
          userInput: {
            Board_Name: BorardTitle,
          },
        },
      });
      handleCloseNewColumn();
      SuccessToast(`Board Name Edited  successfully!`);
    } catch (error) {
      ErrorToast(`Error While Editing  board name'`);
      console.error(error);
    } finally {
      setRenameId("");
    }
  };
  // Use the useEventListener hook from usehooks-ts to listen for keydown events
  useEventListener("keydown", handleKeyDown);
  if (boardLoading) {
    return <Loading />;
  }
  if (boardError) {
    return <center>Error:{boardError.message}</center>;
  }
  const goToAbout = (element) => {
    navigate(`/StatusBoard/${element?._id}`);
  };
  return (
    <>
      <Header>
        <TextHeader>Boards</TextHeader>
      </Header>
      <Container>
        {boardData?.GetAllTaskManagementBoard.map((element, index) =>
          RenameId === element._id ? (
            <HeaderInputBox>
              <TitleEditInput
                placeholder="Enter Board name..."
                value={BorardTitle}
                onChange={handleEDitTitlechange}
                autoFocus
              />
              <EditButtons>
                <IconButton onClick={handleEditTitleBoard}>
                  <FaCheck size={14} />
                </IconButton>
                <IconButton
                  onClick={() => {
                    setRenameId("");
                  }}
                >
                  <FaTimes size={14} />
                </IconButton>
              </EditButtons>
            </HeaderInputBox>
          ) : (
            <div onClick={() => goToAbout(element)} className="board-link-container">
              <BoxContainer key={index}>
                <IconContainer>
                  {access && (
                    <>
                      <SlOptions
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowOptions(!showOptions);
                          setSelctedId(element?._id);
                        }}
                      />
                      {seletedId === element?._id && (
                        <OutsideClick setToggled={setShowOptions}>
                          <OptionsMenu show={showOptions}>
                            <OptionItem
                              onClick={(e) => {
                                e.stopPropagation();
                                setRenameId(element?._id);
                                setBoardTitle(element?.Board_Name);
                              }}
                            >
                              Rename
                            </OptionItem>
                            <OptionItem
                              onClick={(e) => {
                                e.stopPropagation();
                                settoggle(!toggle);
                              }}
                            >
                              Delete
                            </OptionItem>
                          </OptionsMenu>
                        </OutsideClick>
                      )}
                    </>
                  )}
                </IconContainer>
                <Text>{element?.Board_Name}</Text>
              </BoxContainer>
            </div>
          )
        )}
        {isAddingColumn ? (
          <HeaderInputBox>
            <TitleEditInput
              placeholder="Enter Board name..."
              value={boardName}
              onChange={handleNewColumnNameChange}
              autoFocus
            />
            <EditButtons>
              <IconButton onClick={handleAddNewColumn}>
                <FaCheck size={14} />
              </IconButton>
              <IconButton onClick={handleCloseNewColumn}>
                <FaTimes size={14} />
              </IconButton>
            </EditButtons>
          </HeaderInputBox>
        ) : (
          <IconButton onClick={handleOpenNewColumn}>
            <FaPlus size={20} />
          </IconButton>
        )}
      </Container>
      <DeleteBoard toggle={toggle} settoggle={settoggle} DeleteLoad={DeleteLoading} handleClick={handleDeleteBoard} />
    </>
  );
};

export default StatusBoard;
// Styled components for New Column Form
const HeaderInputBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleEditInput = styled.input`
  font-size: 1rem;
  font-weight: bold;
  padding: 8px;
  border: 1px solid #dfe1e6;
  border-radius: 3px;
  width: calc(100% - 16px); /* Account for padding */
  box-sizing: border-box;
  &:focus {
    outline: none;
    border: 2px solid #388bff;
    box-shadow: none;
  }
`;
const IconButton = styled.button`
  border: none;
  color: #42526e;
  background: #ffffff;
  border-radius: 3px;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 4px; // Space between buttons
  box-shadow: 0 2px 0 rgba(9, 30, 66, 0.25);

  &:hover {
    background-color: #ebecf0;
  }

  &:active {
    background-color: #dfe1e6;
  }
`;
const EditButtons = styled.div`
  display: flex;
  align-items: center;
  margin-left: 150px; // Space from input box
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 1.5rem;
  a {
    text-decoration: none;
  }
  padding-top: 1rem;
  padding-left: 1rem;
`;
const TextHeader = styled.h4`
  font-family: sans-serif;
  font-size: 1.5rem;
`;
